import React from 'react'
import { numberFormat } from 'components/helper'
import { SimpleTable } from 'components/Ui'

const TopPerformer = ({ data = [], className }) => {
    return (
        <div className="grid grid-cols-1 gap-x-4 gap-y-4">
            <SimpleTable>
                <thead>
                    <SimpleTable.TR>
                        <SimpleTable.TH>
                            Transport Service Provider Name
                        </SimpleTable.TH>
                        <SimpleTable.TH>Total Invoices</SimpleTable.TH>
                        <SimpleTable.TH>Total Difference</SimpleTable.TH>
                    </SimpleTable.TR>
                </thead>
                <tbody>
                    {(data ?? [])?.map((item, index) => (
                        <SimpleTable.TR key={`asn-${index}`}>
                            <SimpleTable.TD>{item?.name}</SimpleTable.TD>
                            <SimpleTable.TD>
                                {item?.total_invoices}
                            </SimpleTable.TD>
                            <SimpleTable.TD>
                                {numberFormat(item?.total_difference, 'AUD')}
                            </SimpleTable.TD>
                        </SimpleTable.TR>
                    ))}
                </tbody>
            </SimpleTable>
        </div>
    )
}

export default TopPerformer
